import { TOFE_VERSION } from '../constants';

let currentBuildId: string | undefined;

/**
 * Stores the build id loaded from `build.json` at startup (`<version>-<commit>`, for example
 * `2.18.1-dev-a1b2c3d4`). Passing an empty or missing value clears it.
 */
export const setBuildId = (buildId?: string | null): void => {
  currentBuildId = buildId?.trim() || undefined;
};

/**
 * The id used to bust the browser cache of runtime assets: the build id when `build.json` was
 * loaded, otherwise the app version, so URLs are never left unversioned (for example in
 * `npm start`, where there is no `build.json`).
 */
export const getBuildId = (): string => currentBuildId ?? TOFE_VERSION;
